import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "../../lib/api";
import { inputCls, labelCls } from "./shared";

export default function SettingsTab() {
  const [form, setForm] = useState({ event_name: "", event_date: "", workload: "" });

  useEffect(() => {
    let cancelled = false;
    api.get("/settings")
      .then((r) => { if (!cancelled) setForm(r.data); })
      .catch((e) => console.error("Falha ao carregar configurações:", e));
    return () => { cancelled = true; };
  }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.put("/admin/settings", form);
      toast.success("Configurações salvas");
    } catch (err) { toast.error(formatApiError(err)); }
  };

  return (
    <form onSubmit={save} className="card-metric space-y-4 max-w-xl">
      <h3 className="text-lg font-semibold text-white">Dados do evento (usados no certificado e no lobby)</h3>
      <div>
        <label className={labelCls}>Nome do evento</label>
        <input required value={form.event_name} onChange={(e) => setForm({ ...form, event_name: e.target.value })} className={inputCls} data-testid="settings-event-name-input" />
      </div>
      <div>
        <label className={labelCls}>Data / edição</label>
        <input value={form.event_date} onChange={(e) => setForm({ ...form, event_date: e.target.value })} className={inputCls} placeholder="Ex: 15 e 16 de agosto de 2026" data-testid="settings-event-date-input" />
      </div>
      <div>
        <label className={labelCls}>Carga horária (certificado)</label>
        <input value={form.workload} onChange={(e) => setForm({ ...form, workload: e.target.value })} className={inputCls} placeholder="Ex: 16 horas" data-testid="settings-workload-input" />
      </div>
      <button type="submit" className="btn-primary" data-testid="settings-save-btn">Salvar</button>
    </form>
  );
}
